import environment from '@environment';
import { MakePaymentPayloadDTO } from 'core/models/account/make-payment-payload.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { PaymentService } from 'core/stores/payment/interfaces/payment-service';
import { NumberUtils } from 'utils/number.utils';
import { PayAtTokenizeResponse } from './payment-pay-at';

export interface PayAtExternalResponse {
  redirectUrl: string;
  target?: string;
}

export class PayAtLinkPaymentService implements PaymentService<MakePaymentPayloadDTO> {
  public canStatusPoll = false;
  public canRefetchPoll = false;
  public canTimeoutPoll = false;

  private apiBuilder = new EndpointHelper(`${environment.UTILITY_API_URI}/payat`);

  MakePayment(request?: Partial<MakePaymentPayloadDTO>): Promise<PayAtExternalResponse> {
    const useAmountOverride = !!request?.amountToPayOverride?.length;
    const amountNumber = +`${request?.amountToPayOverride}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    const { paymentAttribution } = request?.paymentMetaData || {};

    return Promise.resolve({
      redirectUrl: `${environment.PAY_AT_EXTERNAL_PAYMENT_LINK}/${request?.customerNumber}?jid=${paymentAttribution
        }${useAmountOverride ? '&amount=' + amountInCents : ''}`,
      transactionId: '',
      paymentType: '',
      target: '_blank',
    });
  }

  TokenLinks(requestBody?: any) {
    const url = this.apiBuilder.createUrl('token')
      .addRouteParam('paymentLink')
      .build();

    return HttpClient.GetInstance.post<unknown, PayAtTokenizeResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return {
            redirectUrl: response.tokenPaymentUrl,
            transactionId: response.referenceKey,
            paymentType: `${response.responseCode}`
          }
        },
        err => {
          console.error('Failed request', err);
          return Promise.reject(err);
        });
  }

  PaymentStatus(country: string, transactionId: string) {
    return Promise.reject(`PayAtLinkPaymentService -> PaymentStatus not implemented`);
  }

  RefetchPayment() {
    return Promise.reject('PayAtLinkPaymentService -> RefetchPayment Not Implemented')
  }
}